import { createStore } from 'zustand/vanilla';

export type CreditState = {
    credits: number;
};

export type CreditActions = {
    set: (credits: number) => void;
};

export type CreditStore = CreditState & CreditActions;

export const defaultInitState: CreditState = {
    credits: 0,
};

export const createCreditStore = (initState: CreditState = defaultInitState) => createStore<CreditStore>()((st) => ({
    ...initState,
    set: (credits) => st({ credits }),
    }));
